import { CmsPublicationListAdmin } from '../../../../components/Cms';

export function CmsPublications() {
  return <CmsPublicationListAdmin />;
}
